import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { POST } from "../../services/api";

// Async Thunk for file upload
export const uploadFile = createAsyncThunk(
  "upload/uploadFile",
  async (file, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await POST('/common/upload', formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data; // Assuming API returns uploaded file URL
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const UploadSlice = createSlice({
  name: "upload",
  initialState: {
    fileUrl: null,
    uploadLoading: false,
    error: null,
  },
  reducers: {
    clearUploadState: (state) => {
      state.fileUrl = null;
      state.uploadLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadFile.pending, (state) => {
        state.uploadLoading = true;
        state.error = null;
      })
      .addCase(uploadFile.fulfilled, (state, action) => {
        state.uploadLoading = false;
        state.fileUrl = action.payload.result; // Store file URL
      })
      .addCase(uploadFile.rejected, (state, action) => {
        state.uploadLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearUploadState } = UploadSlice.actions;
export default UploadSlice.reducer;





